// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { AppConfig, InitialUserPrivilegeRequest } from "@config/config";
import { APIService } from "./apiService";

// TODO : Add the API call to get the user privileges
export const getUserPrivileges = () => {
  return new Promise<number[]>((resolve, reject) => {
    if (InitialUserPrivilegeRequest) {
      APIService.getInstance()
        .get(AppConfig.serviceUrls.userPrivileges)
        .then(
          (res) => {
            if (res.status === 200) {
              var privileges: number[] = res.data.privileges;
              resolve(privileges);
            }
            reject("error");
          },
          (error) => {
            reject("error");
          }
        );
    } else {
      resolve([]);
    }
  });
};
